import { useFormikContext } from "formik";
import { TaskCreate } from "@common/contracts/task.contract";
import { TaskType } from "@common/types/task";
import { PersistableView } from "@common/types/views/views";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import {
    getStatementRetrievalTitle,
    isGeneratedStatementTitle,
} from "./statementRetrieval";
import { buildWorkflowView, isPeriodTaskType } from "./taskWorkflow";

type WorkflowFilters = NonNullable<PersistableView["filters"]>;

export const useWorkflowViewUpdater = () => {
    const formik = useFormikContext<TaskCreate>();
    const accounts = useFinancialAccounts();

    return (filtersPatch: Partial<WorkflowFilters>) => {
        const { type, view, title } = formik.values;
        if (!isPeriodTaskType(type)) {
            return;
        }
        const currentView =
            view ??
            buildWorkflowView({
                taskType: type,
                periodStart: "",
                periodEnd: "",
            });
        const nextView: PersistableView = {
            ...currentView,
            filters: { ...currentView.filters, ...filtersPatch },
        };

        const nextTitle = getStatementRetrievalTitle({
            filters: nextView.filters,
            accounts,
        });
        const shouldRetitle =
            type === TaskType.DOCUMENT_RETRIEVAL &&
            nextTitle !== null &&
            isGeneratedStatementTitle(title);

        void formik.setValues({
            ...formik.values,
            view: nextView,
            ...(shouldRetitle ? { title: nextTitle } : {}),
        });
    };
};
